export default "__VITE_ASSET__CfmRgpmC__"